import { render, staticRenderFns } from "./LabelDrawer.vue?vue&type=template&id=4113536c&"
import script from "./LabelDrawer.vue?vue&type=script&lang=js&"
export * from "./LabelDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports